<template>
    <div id="app">
        <!-- Dynamic GTM Loader -->
        <GTMLoader v-if="currentHotelGtmId" :key="gtmKey" :gtm-id="currentHotelGtmId" />
        <!-- Platform container for booking-engine funnel events (separate data layer) -->
        <GTMLoader gtm-id="GTM-W6P52LJV" data-layer-name="reserveportLayer" />

        <transition name="slide-fade">
            <router-view />
        </transition>
    </div>
</template>

<script>
import GTMLoader from './components/GTMLoader.vue';

export default {
    name: 'App',
    components: { GTMLoader },
    props: [
        'id', 'multiproperty',
        'clientemail', 'occupancy',
        'coupon_code', 'ipn_profile',
        'listing', 'account_type',
        'layout'
    ],
    data() {
        return {
            gtmKey: 0
        }
    },
    computed: {
        currentHotelGtmId() {
            return this.$store.state.gtmContainerId || null;
        }
    },
    watch: {
        currentHotelGtmId(newVal, oldVal) {
            if (newVal !== oldVal) {
                // Force re-render by changing the key
                this.gtmKey += 1;
                // console.log('gtm was updated');
            }
        }
    }
}
</script>

<style>
.slide-fade-enter-active {
    transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-leave-active {
    transition: all 0.2s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/App.vue